import { render, staticRenderFns } from "./QuizActivityCatalogs.vue?vue&type=template&id=104be070&"
import script from "./QuizActivityCatalogs.vue?vue&type=script&lang=js&"
export * from "./QuizActivityCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports